import type { Step } from "react-joyride";

export const monthlyReportFormEditTourSteps: Step[] = [
  {
    target: "body",
    content:
      "ແກ້ໄຂລາຍງານປະຈໍາເດືອນ. ປ່ຽນແປງຂໍ້ມູນ ແລ້ວກົດບັນທຶກ.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="monthly-report-form-edit-back"]',
    content:
      "ຍົກເລີກ ແລະ ກັບໄປຫນ້າລາຍລະອຽດ. ກົດປຸ່ມ ? ເພື່ອເລີ່ມທົດສອບການນຳທາງ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="monthly-report-form-edit-form"]',
    content:
      "ແກ້ໄຂເດືອນ, ປີ, ພະແນກ, ຊື່ ຫຼື ເອກະສານ. ກົດບັນທຶກເພື່ອອັບເດດ.",
    placement: "top",
  },
];
